module.exports = __webpack_public_path__ + "9c6fc24712f2548c634ad928c03ee4e9.gif";